import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { get, noop } from 'lodash';
// Icons
import CheckIcon from '@material-ui/icons/Check';

import { COURSE_STATUS as STATUS, PASSING_PERCENT } from '@nereus/shared/constants';
import { checkIfCanAlwaysAccessCourse } from 'reduxConfig/selectors';
import ActionButton from './ActionButton';
import TakeExamsButton from './TakeExamsButton';
import Category from './Category';
import Button from '../../Button';
import {
  NAME_COLUMN_XS,
  CODE_COLUMN_XS,
  BUTTONS_COLUMN_XS,
} from '../constants';
// import { useLazyQuery, gql } from '@apollo/client'
// import { EXAM_LIST_PAGE } from 'constants/queries';

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: 8*2,
  },
  containerPointer: {
    cursor: 'pointer',
  },
  icon: {
    borderRadius: 60,
    boxShadow: '0px 0px 2px #888',
    padding: '0.5em 0.6em',
    marginLeft: 8*2,
    cursor: 'pointer',
  },
  categoryContainer: {
    marginTop: 8*2,
  },
}));

const Course = ({
  course,
  setCourseUploadingFor,
  startExpanded,
  disableExpandCollapse,
  hideTakeExamButtons,
  inReviewMode,
  hideActionButtons,
  hideActionButtonsIfAccepted,
  showCategoryItems,
  showExamButtonAsDisabledIfNotAccepted: sEBaDinA,
}) => {
  const classes = useStyles();
  const canAlwaysAccessCourse = useSelector(checkIfCanAlwaysAccessCourse);
  const [passed, setPassed] = useState(false)
  // const [average, setAverage] = useState(0)
  const [expanded, setExpanded] = useState(startExpanded);

  const toggleExpand = disableExpandCollapse
    ? noop
    : () => setExpanded(!expanded)

  const status = get(course, 'userCourse.status');
  const categories = get(course, 'categories', []);

  const hasExams = categories.some(x => x.exams.length > 0);
  const isAccepted = canAlwaysAccessCourse || status === STATUS.accepted;
  
  // const [getUserExamRecords, {}] = useLazyQuery(EXAM_LIST_PAGE, {
  //   variables: {
  //     courseId: Number(course.id),
  //   },
  //   onCompleted(data) {
  //     // console.log(data)
  //     const categories = data.courseCategoriesWithExamFlag.courseCategories
  //       .map(category => {
  //         const exam = category.exams[0]
  //         const average = ((exam.score || 0) / exam.numberOfQuestions)*100

  //         return {
  //           ...category,
  //           items: exam.numberOfQuestions,
  //           score: exam.score || 0,
  //           average
  //         }
  //       })
  //     const total = categories.reduce((acc, curr) => {
  //       acc.items += curr.items
  //       acc.scores += curr.score
  //       return acc
  //     }, {
  //       items: 0,
  //       scores: 0
  //     })
  //     const average = (total.scores/total.items)*100
  //     setAverage(average)
  //     if(average > 0 && average >= PASSING_PERCENT.course) {
  //       setPassed(true)
  //     }
  //   },
  //   onError(error) {
  //     // console.log(error)
  //   }
  // })
  // useEffect(() => {
  //   getUserExamRecords()
  // }, [])
  return (
    <Paper
      component={Grid}
      item
      container
      classes={{ root: [
        classes.container,
        disableExpandCollapse ? null : classes.containerPointer,
      ].filter(x => x).join(' ')}}
      onClick={toggleExpand}
    >
      <Grid item container alignItems='center'>
        <Grid item xs={NAME_COLUMN_XS}>
          <Typography variant='subtitle1'>
            {course.name}
          </Typography>
        </Grid>

        <Grid item xs={CODE_COLUMN_XS}>
          <Typography variant='subtitle1'>
            {course.code}
          </Typography>
        </Grid>

        <Grid container item xs={BUTTONS_COLUMN_XS} justify='flex-end'>
          { hasExams && !hideTakeExamButtons && (isAccepted || sEBaDinA) && (
            <TakeExamsButton
              courseId={Number(course.id)}
              disabled={!isAccepted}
            />
          )}

          {
            (() => {
              if(!hideActionButtons) {
                return (
                  <ActionButton
                    course={course}
                    status={status}
                    setCourseUploadingFor={setCourseUploadingFor}
                    hideActionButtonsIfAccepted={hideActionButtonsIfAccepted}
                  />
                )
              }
            })()
          }
          
          {
            !disableExpandCollapse && (
              <div className={classes.icon}>
                {expanded ? <ExpandLess /> : <ExpandMore />}
              </div>
            )
          }
        </Grid>

        <Collapse
          component={Grid}
          item
          container
          classes={{ container: classes.categoryContainer }}
          in={expanded}
          timeout='auto'
          unmountOnExit
        >
            <Grid item container spacing={2}>
              {categories.map(category => {
                return (
                  <Grid item key={category.id} xs={12}>
                    <Category
                      removeReviewButton={passed}
                      courseId={course.id}
                      id={category.id}
                      name={category.name}
                      hasExams={category.exams.length > 0}
                      inReviewMode={inReviewMode}
                      items={category.items}
                      canReview={isAccepted}
                      showCategoryItems={showCategoryItems}
                    />
                  </Grid>
                )
              })}
            </Grid>
        </Collapse>
      </Grid>
    </Paper>
  )
}

Course.propTypes = {
  course: PropTypes.object.isRequired,
  setCourseUploadingFor: PropTypes.func,
  startExpanded: PropTypes.bool,
  disableExpandCollapse: PropTypes.bool,
  hideTakeExamButtons: PropTypes.bool,
  inReviewMode: PropTypes.bool,
  hideActionButtons: PropTypes.bool,
  hideActionButtonsIfAccepted: PropTypes.bool,
  showCategoryItems: PropTypes.bool,
  showExamButtonAsDisabledIfNotAccepted: PropTypes.bool,
}

Course.defaultProps = {
  startExpanded: false,
  disableExpandCollapse: false,
  hideTakeExamButtons: false,
  inReviewMode: false,
  hideActionButtons: false,
  hideActionButtonsIfAccepted: false,
  showCategoryItems: false,
  showExamButtonAsDisabledIfNotAccepted: false,
}

export default memo(Course);
